import event1 from "../assets/event1.jpg"
import event2 from "../assets/event2.jpg"
import event21 from "../assets/event2.2.jpg"
import event3 from "../assets/event3.jpg"
import event41 from "../assets/event4.1.jpg"
import event42 from "../assets/event4.2.jpg"
import event5 from "../assets/event5.jpg"
import event52 from "../assets/event5.2.jpg"
import event53 from "../assets/event5.3.jpg"

export const events = [
    {
        id:1,
        title:"Outcome Based Education OBE এর উপর সোনারগাঁও ইউনিভার্সিটিতে দুইদিন ব্যাপী ওয়ার্কশপ",
        image:event1,
        gellary_image:[
            event1,
            
            
        ],
        description:`উক্ত OBE ওয়ার্কশপে Outcome Based Education এর ইউনিভারসিটির Vision, Mission, PLOs, CLOs, Assessment, Rubrics ইত্যাদি আলোচনা করা হয়। তাছাড়া Outcome Based Education এর ইমপ্লিমেন্টেশন ও অ্যাক্রিটেশন নিয়ে OBE Specialist ইঞ্জি: ফারুক হোসেন বিশদভাবে আলোচনা করেন। প্রধান অতিথি হিসেবে উপস্থিত থাকেন উক্ত ইউনিভার্সিটির ভিসি প্রফেসর শামীম আরা হাসান ।`
    },
      {
        id:2,
        title:"জাতীয় কবি কাজী নজরুল ইসলাম ইউনিভার্সিটিতে Outcome Based Education OBE  এর উপর দুইদিন  ব্যাপী ওয়ার্কশপ ।",
        image:event5,
        gellary_image:[
            event5,
            event52,
            event53
            
        ],
        description:`জাতীয় কবি কাজী নজরুল ইসলাম বিশ্ববিদ্যালয়ের সামাজিক বিজ্ঞান ও আইন অনুষদের শিক্ষকদের অংশগ্রহণে ‘OBE Curriculum’ শীর্ষক দুই দিনব্যাপী প্রশিক্ষণ কর্মশালা শেষ হয়েছে। বিশ্ববিদ্যালয়ের মাননীয় উপাচার্য প্রফেসর ড. মো. জাহাঙ্গীর আলমের সভাপতিত্বে ২৯ মে ২০২৫ তারিখ বৃহস্পতিবার দুপুরে পুরনো প্রশাসনিক ভবনের কনফারেন্স কক্ষে প্রশিক্ষণ কর্মশালাটির সমাপনী অনুষ্ঠিত হয়। উক্ত OBE ওয়ার্কশপে Outcome Based Education এর ইউনিভারসিটির Vision, Mission, PLOs, CLOs, Assessment, Rubrics ইত্যাদি আলোচনা করা হয়। তাছাড়া Outcome Based Education এর ইমপ্লিমেন্টেশন ও অ্যাক্রিটেশন নিয়ে OBE Specialist ইঞ্জি: ফারুক হোসেন বিশদভাবে আলোচনা করেন। সমাপনী অধিবেশনে প্রধান অতিথি হিসেবে বক্তব্য দেন বাংলাদেশ বিশ্ববিদ্যালয় মঞ্জুরী কমিশনের সদস্য প্রফেসর ড. মাছুমা হাবিব। দুই দিনব্যাপী প্রশিক্ষণ কর্মশালায় রিসোর্স পার্সন হিসেবে উপস্থিত ছিলেন নোয়াখালি বিজ্ঞান ও প্রযুক্তি বিশ্ববিদ্যালয়ের মাননীয় উপাচার্য প্রফেসর ড. মোহাম্মদ ইসমাইল, ইন্ডিপেন্ডেন্ট ইউনিভার্সিটি বাংলাদেশের প্রফেসর ড. মো. আব্দুর রাজ্জাক, বাংলাদেশ বিশ^বিদ্যালয় মঞ্জুরী কমিশনের স্ট্র্যাটেজিক প্ল্যানিং এন্ড কোয়ালিটি অ্যাশুরেন্স ডিভিশনের পরিচালক ড. দুর্গা রানী সরকার, বাংলাদেশ বিশ্ববিদ্যালয় মঞ্জুরী কমিশনের স্ট্র্যাটেজিক প্ল্যানিং এন্ড কোয়ালিটি অ্যাশুরেন্স ডিভিশনের উপ-পরিচালক প্রকৌশলী মোহাম্মদ মনির উল্লাহ ।`
    },
   
    {
        id:3,
        title:"Primeasia University তে Outcome Based Education OBE এর উপর একদিন ব্যাপী সেমিনার",
        image:event3,
        gellary_image:[
            event3
            
        ],
        description:`উক্ত OBE সেমিনারে Outcome Based Education এর, গুরুত্ব ইমপ্লিমেন্টেশন ও অ্যাক্রিটেশন নিয়ে OBE Specialist ইঞ্জি: ফারুক হোসেন বিশদভাবে আলোচনা করেন। প্রধান অতিথি হিসেবে উপস্থিত থাকেন উক্ত ইউনিভার্সিটির  IQAC ডিপার্টমেন্টের পরিচালক`
    },
    {
        id:4,
        title:"বাংলাদেশ ইউনিভার্সিটি অফ বিজনেস অ্যান্ড টেকনোলজি BUBT তে  Outcome Based Education OBE এর উপর একদিন ব্যাপী সেমিনার",
        image:event41,
        gellary_image:[
            event41,
            event42
            
        ],
        description:`উক্ত OBE সেমিনারে Outcome Based Education এর, গুরুত্ব ইমপ্লিমেন্টেশন ও অ্যাক্রিটেশন নিয়ে OBE Specialist ইঞ্জি: ফারুক হোসেন বিশদভাবে আলোচনা করেন। প্রধান অতিথি হিসেবে উপস্থিত থাকেন উক্ত ইউনিভার্সিটির  IQAC ডিপার্টমেন্টের পরিচালক.`
    },
  

     {
        id:5,
        title:"Outcome Based Education OBE এর উপর সোনারগাঁও ইউনিভার্সিটিতে একদিন ব্যাপী সেমিনার",
        image:event2,
        gellary_image:[
            event2,
            event21
            
        ],
        description:`উক্ত OBE সেমিনারে Outcome Based Education এর, গুরুত্ব ইমপ্লিমেন্টেশন ও অ্যাক্রিটেশন নিয়ে OBE Specialist ইঞ্জি: ফারুক হোসেন বিশদভাবে আলোচনা করেন। প্রধান অতিথি হিসেবে উপস্থিত থাকেন উক্ত ইউনিভার্সিটির ভিসি প্রফেসর শামিম আরা হাসান ও IQAC ডিপার্টমেন্টের পরিচালক প্রফেসর মোস্তফা কামাল।`
    },
 
]